export const constants = {
  refractPath: '/cms',
};
